module.exports = __webpack_public_path__ + "img/sms.2998d3bc.webp";